import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { historyAPI } from "../api/api";
import { HistoryActionTypes } from "../actions/actionTypes";

function* getHistoryUsers(action) {
    try {
        if (action.payload.search === null) {
            yield put({
                type: HistoryActionTypes.GET_HISTORY_USERS_SUCCESS,
                payload: {
                    users: {
                        results: [],
                        count: 0
                    }
                }
            });
        } else {
            const usersResponse = yield call(() =>
                historyAPI.getHistoryUsers({
                    skip: 0,
                    top: 1000000,
                    search: action.payload.search
                })
            );

            yield put({
                type: HistoryActionTypes.GET_HISTORY_USERS_SUCCESS,
                payload: {
                    users: usersResponse.data
                }
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting History Users.");

        yield put({
            type: HistoryActionTypes.GET_HISTORY_USERS_FAIL,
            message: e.message
        });
    }
}

export function* getHistoryUsersWatcher() {
    yield takeLatest(HistoryActionTypes.GET_HISTORY_USERS, getHistoryUsers);
}
